<div class="sidebar-wrapper left-side-menu" style="margin-top:-20px">
  <div class="sidebar-linklist-wrapper menu-container">
    <div class="link-list-wrapper div-container">
      <ul class="link-list">
        <ng-container *ngFor="let item of data; let i = index">
          <li>
            <ng-template [ngIf]="!item.below.length" [ngIfElse]="recursive">
              <a class="list-item medium menu fix-collapsing no-underline" [routerLink]="item?.link">
                <span class="no-underline">{{ item!.title }}</span>
                <hr class="divider">
              </a>
            </ng-template>

            <ng-template #recursive>
              <a class="list-item medium right-icon menu no-underline" id="link-{{i}}" href="#collapse-{{i}}"
                data-bs-toggle="collapse" attr.aria-controls="collapse-{{i}}">
                <span class="fragment-link no-underline" (click)="toggleCollapse($event, item?.link)">{{ item.title
                  }}</span>
                <svg class="icon icon-sm icon-primary right icon" aria-hidden="true"
                  style="margin-right:8px!important;">
                  <use href="assets/svg/sprites.svg#it-expand"></use>
                </svg>

                <hr class="divider">
              </a>




              <!-- <a class="list-item medium right-icon menu" [routerLink]="item?.link" id="link-{{i}}"
                href="javascript:void(0);" data-bs-toggle="collapse" [attr.aria-expanded]="isOpen[i]"
                (click)="toggleCollapse(i)">
                <span class="list-item-title-icon-wrapper">
                  <span class="fragment-link">{{ item.title }}</span>
                  <svg class="icon icon-sm icon-primary right icon" aria-hidden="true">
                    <use href="assets/svg/sprites.svg#it-expand"></use>
                  </svg>
                </span>
                <hr class="divider">
              </a> -->
              <ul id="collapse-{{i}}" [ngClass]="{'collapse': collapsed}" (click)="handleClick()">
                <item-menu [items]="item.below" [indexMaster]="'' + i"></item-menu>
              </ul>
            </ng-template>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>